import { useCallback, useEffect, useRef } from 'react';
import { useDrawsUpdated } from '../../hooks/useDrawsUpdated';

// Reuse Dashboard's events, including its cross-tab notifications. No polling.
export const useDiagnosticsUpdates = onRefresh => {
  const callback = useRef(onRefresh);
  const timer = useRef(null);
  callback.current = onRefresh;
  const schedule = useCallback((reason = 'draw') => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => callback.current(reason), 75);
  }, []);
  useDrawsUpdated(() => schedule('draw')); // keep selected tab
  useEffect(() => {
    const storage = e => { if (e.key === 'euromillions:last_draw_update') schedule(); };
    const visible = () => { if (document.visibilityState === 'visible') schedule('focus'); };
    const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('euromillions') : null;
    if (channel) channel.onmessage = e => { if (e.data === 'draws-updated') schedule(); };
    window.addEventListener('storage', storage);
    window.addEventListener('focus', visible);
    document.addEventListener('visibilitychange', visible);
    return () => {
      clearTimeout(timer.current);
      channel?.close();
      window.removeEventListener('storage', storage);
      window.removeEventListener('focus', visible);
      document.removeEventListener('visibilitychange', visible);
    };
  }, [schedule]);
};
